import React from "react";
import styles from "./ContentSidebarLayout.module.css";

export interface ContentSidebarLayoutProps {
  /** Thin rail column — typically a `NavRail`. */
  sidebar: React.ReactNode;
  /** Fluid main column. */
  children: React.ReactNode;
}

/**
 * Two-panel shell: a thin `flex-shrink: 0` rail column beside a fluid main
 * column (`flex: 1; min-width: 0`). The container stays `position: relative`
 * and `overflow: visible` so a hover/focus overlay rendered by the sidebar
 * (see `NavRail`) can float out over the main column without shifting
 * layout or being clipped. Stacks to a single column under a narrow
 * breakpoint.
 *
 * Named "Legacy" because `AppLayout` (built on Astryx's `AppShell`) has taken
 * over the app-level layout-shell role; this component remains for its one
 * surviving consumer (`admin/script_templates/script_builder.tsx`), which
 * pairs it with the also-legacy `NavRail`.
 */
const ContentSidebarLayout = ({ sidebar, children }: ContentSidebarLayoutProps): React.ReactElement => {
  return (
    <div className={styles.layout}>
      <div className={styles.rail}>{sidebar}</div>
      <div className={styles.main}>{children}</div>
    </div>
  );
};

export default ContentSidebarLayout;
